/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ApolloModule, Apollo } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { onError } from 'apollo-link-error';
import { environment } from '../environments/environment';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from './auth-guard.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PushNotificationsModule } from 'ng-push';
import { ToastrModule } from 'ngx-toastr';
import { Ng2CompleterModule } from 'ng2-completer';
import { FlatpickrModule } from 'angularx-flatpickr';
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import { UnsavedChangesGuard } from './unsaved-changes-guard.service';
import { UrlSerializer, DefaultUrlSerializer, UrlTree } from '@angular/router';
import { ApolloLink } from 'apollo-link';
import { Router } from '@angular/router';


const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem('auth_app_token') ? JSON.parse(localStorage.getItem('auth_app_token')).value : "";
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : '',
		},
	}
});

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
	parse(url: string): UrlTree {
		return (url.includes('pages/')) ? super.parse(url.toLowerCase()) : super.parse(url);
	}
}

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		ApolloModule,
		HttpLinkModule,
		FormsModule,
		ReactiveFormsModule,
		Ng2CompleterModule,
		PushNotificationsModule,
		ToastrModule.forRoot({
			timeOut: 3600,
			newestOnTop: true,
			preventDuplicates: true,
			positionClass: 'toast-bottom-right',
			easing: 'ease-in ease-out',
		}),
		FlatpickrModule.forRoot({
			time24hr: true,
			disableMobile: true,
			enableTime: true,
			convertModelValue: true,
			altInput: true,
			plugins: [
				confirmDatePlugin({}),
			],
		}),
		NgbModule.forRoot(),
		ThemeModule.forRoot(),
		CoreModule.forRoot(),
	],
	bootstrap: [AppComponent],
	providers: [
		AuthGuard,
		{
			provide: APP_BASE_HREF,
			useValue: '/',
		},
		UnsavedChangesGuard,
		{
			provide: APP_BASE_HREF,
			useValue: '/',
		},
		DatePipe,
		{
			provide: UrlSerializer,
			useClass: LowerCaseUrlSerializer,
		},
	],
	exports: [],
})
export class AppModule {
	constructor(apollo: Apollo, httpLink: HttpLink, private router: Router) {

		apollo.create({
			link: ApolloLink.from([
				onError(({graphQLErrors, networkError}) => {
					if (graphQLErrors) {
						graphQLErrors.map(({message, locations, path}) =>
							console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
						);
					}
					if (networkError) {
						console.log(`[Network error]:`, networkError);
						switch ((networkError as HttpErrorResponse).status) {
							case 401:
								localStorage.removeItem('auth_app_token');
								this.router.navigate(['auth/login']);
								networkError.message = 'You have been logged out.'
								break;
							default:
								// window.alert('A Network error has occurred, please refresh the page and try again. If you experience this issue multiple times please get in touch.')
						}
					}
				}),
				authLink.concat(httpLink.create({uri: environment.apiUrl})),
			]),
			cache: new InMemoryCache(),
		});
	}
}
